import { useCreate, useDelete, useUpdate } from '@/data/mutations';
import type { IMaterialObject, ResponseType } from '@/types';

/** JSON quick-create (editor flows: locations/sublocations by name). */
export const useCreateFeature = useCreate.feature<
    { project_id: number; data: { name: string; feature_type_id: number; parent_id?: number; description?: string } },
    ResponseType<IMaterialObject>
>({
    endpoint: ({ project_id }) => `projects/${project_id}/features`,
    body: ({ data }) => data,
});

/** FormData create (modal flows that may carry assets). */
export const useCreateFeatures = useCreate.feature<{ project_id: number; data: FormData }, ResponseType<IMaterialObject>>({
    endpoint: ({ project_id }) => `projects/${project_id}/features`,
    body: ({ data }) => data,
});

export const useUpdateFeature = useUpdate.feature<
    { project_id: number; feature_id: number; data: FormData },
    ResponseType<IMaterialObject>
>({
    endpoint: ({ project_id, feature_id }) => `projects/${project_id}/features/${feature_id}?_method=PUT`,
    body: ({ data }) => data,
});

export const useDeleteFeature = useDelete.feature<{ project_id: number; feature_id: number }, ResponseType<IMaterialObject>>({
    method: 'DELETE',
    endpoint: ({ project_id, feature_id }) => `projects/${project_id}/features/${feature_id}`,
});
